export default __webpack_public_path__ + "static/media/avatar-4.e3794c38.png";